import React, { useState } from 'react'
import { ReactComponent as ChevronDown } from '../../../assets/icons/chevron-down.svg'
import { ReactComponent as ChevronUp } from '../../../assets/icons/chevron-up.svg'
import Card from '../index'
import * as S from './styles'

const ExpandableCard = ({ children, icon, title, subtitle, loading = false, customTitleColor, customIconColor }) => {
  const [expanded, setExpanded] = useState(false)
  const chevronIcon = {
    true: <ChevronUp />,
    false: <ChevronDown />
  }
  return (
    <S.CardWrapper>
      <Card loading={loading} full>
        <S.CardBody>
          <S.CardHeader customIconColor={customIconColor} onClick={() => setExpanded(!expanded)}>
            {icon && icon}
            <S.CardTitle customTitleColor={customTitleColor}>
              <h1>{title && title}</h1>
              <h2>{subtitle && subtitle}</h2>
            </S.CardTitle>
            <S.Chevron>
              {chevronIcon[expanded]}
            </S.Chevron>
          </S.CardHeader>
        </S.CardBody>
        {
          (expanded && children) &&
          <S.ExpandedContent>
            {children}
          </S.ExpandedContent>
        }
      </Card>
    </S.CardWrapper>
  )
}

export default ExpandableCard
